import PhoneCarousel from './PhoneCarousel';

const FeaturesSection = () => {
  return <PhoneCarousel />;
};

export default FeaturesSection;
